import AxiosFactory from '@/services/axiosFactory';
import type { LocaleMessageObject } from 'vue-i18n/dist/vue-i18n.d.ts';
import type { AxiosResponse } from 'axios';

export default class DictionaryService {
    private client = AxiosFactory.create({
        baseURL: '/umbraco/'
    });

    public async Get(lang: string): Promise<AxiosResponse<LocaleMessageObject>> {
        return (await this.client).get('dictionaries.json?l=' + lang);
    }
}
